import { useFormik } from "formik";
import { useState } from "react";
import { Button, Grid, InputLabel, Typography, Box } from "@mui/material";
import { FormControl, MenuItem, Select, TextField } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import {CloudUpload,Info}from "@mui/icons-material";
import InputAdornment from "@mui/material/InputAdornment";
import { initialValues, validationSchema } from "./validation";
import Alert from "../../../../assets/images/sign-up/alert.png";
import VehicleDetails from "./VehicleDetails";
import NocDetail from "./NocDetails";
import ApiClient from "helpers/ApiClient";
import "./styles.scss";

const VehicleRegistration = ({ setToggleSnackbar, userId }: any) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [progressBar, setProgressBar] = useState(false);
  const [verifyDetails, setVerifyDetails] = useState(false);
  const [NocDetails, setNocDetails] = useState(false);
  const [supportModal, setSupportModal] = useState(false);

  const handleOpen = () => {
    setSupportModal(true);
  };
  const handleClose = () => {
    setSupportModal(false);
  };

  const { values, errors, touched, setFieldValue, handleChange, handleSubmit, handleBlur } =
    useFormik({
      initialValues,
      validationSchema,
      onSubmit: () => {
        registerVehicle(values);
      },
    });

  const registerVehicle = (values: any) => {
    setIsSubmitted(true);
    setProgressBar(true);
    let VehicleFormData = new FormData();
    VehicleFormData.append("vehicleNumber", values.regNumber);
    VehicleFormData.append("ownershipType", values.ownerShipType);
    VehicleFormData.append("userId", userId);
    VehicleFormData.append("file", values.file);

    ApiClient.post("vehicle/add", VehicleFormData)
      .then((res) => {
        setProgressBar(false);
        setNocDetails(true);
      })
      .catch((err: any) => {
        setProgressBar(false);
        setIsSubmitted(false);
        const error = err?.response?.data.message;
        setToggleSnackbar({ message: error, isToggle: true, mode: "error", top: "110px" });
      });
  };

  return (
    <Box className="vehicle-registration">
      {!isSubmitted && (
        <form onSubmit={handleSubmit}>
          <Typography variant="h5" sx={{ mb: "20px", color: "#434242", fontWeight: "500" }}>
            Vehicle Registration
          </Typography>
          <Grid container spacing={2} rowSpacing={4}>
            <Grid item md={12} sm={12} xs={12}>
              <InputLabel
                htmlFor="regNumber"
                className={errors.regNumber && touched.regNumber ? "label-err" : "label"}
              >
                Vehicle Registration Number <span style={{color:'red'}}>*</span>
              </InputLabel>

              <TextField
                name="regNumber"
                sx={{ background: "#fff" }}
                value={values.regNumber}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!(errors.regNumber && touched.regNumber)}
                type="text"
                size="small"
                fullWidth
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {errors.regNumber && touched.regNumber ? (
                        <Info sx={{ color: "#DC3545" }} fontSize="medium" />
                      ) : (
                        ""
                      )}
                    </InputAdornment>
                  ),
                }}
              />

              {errors.regNumber && touched.regNumber && (
                <Typography sx={{ color: "#DC3545" }} variant="body2">
                  {errors.regNumber}
                </Typography>
              )}
            </Grid>
            <Grid item md={12} sm={12} xs={12} sx={{ position: "relative" }}>
              <InputLabel
                htmlFor="ownerShipType"
                className={errors.ownerShipType && touched.ownerShipType ? "label-err" : "label"}
              >
                Ownership Type <span style={{color:'red'}}>*</span>
              </InputLabel>

              <FormControl fullWidth>
                <Select
                  name="ownerShipType"
                  sx={{ background: "#fff" }}
                  size="small"
                  displayEmpty
                  value={values.ownerShipType}
                  onBlur={handleBlur}
                  error={!!(errors.ownerShipType && touched.ownerShipType)}
                  onChange={handleChange}
                  inputProps={{ "aria-label": "Without label" }}
                >
                  <MenuItem value="Leased Owner">Leased Owner</MenuItem>
                  <MenuItem value="Registered Owner">Registered Owner</MenuItem>
                </Select>
                {errors.ownerShipType && touched.ownerShipType && (
                  <Info
                    fontSize="medium"
                    sx={{ color: "#DC3545", position: "absolute", top: "9px", right: "11px" }}
                  />
                )}
              </FormControl>

              {errors.ownerShipType && touched.ownerShipType && (
                <Typography sx={{ color: "#DC3545" }} variant="body2">
                  {errors.ownerShipType}
                </Typography>
              )}
            </Grid>
            {values.ownerShipType && (
              <Grid item md={12} sm={12} sx={{ width: "100%" }}>
                <InputLabel
                  htmlFor="file"
                  className={errors.file && touched.file ? "label-err" : "label"}
                >
                  {values.ownerShipType === "1"
                    ? "Upload No Objection Certificate (NOC)"
                    : "Upload V5C Logbook"} <span style={{color:'red'}}>*</span>
                </InputLabel>

                <TextField
                  name="file"
                  sx={{ background: "#fff" }}
                  fullWidth
                  onChange={(e: any) => setFieldValue("file", e.target.files[0])}
                  error={!!(errors.file && touched.file)}
                  type="file"
                  size="small"
                  variant="outlined"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {errors.file && touched.file ? (
                          <Info sx={{ color: "#DC3545" }} fontSize="medium" />
                        ) : (
                          <CloudUpload />
                        )}
                      </InputAdornment>
                    ),
                  }}
                />

                {errors.file && touched.file && (
                  <Typography sx={{ color: "#DC3545" }} variant="body2">
                    {errors.file}
                  </Typography>
                )}
              </Grid>
            )}
            <Grid item md={12} sm={12} xs={12}>
              <Box sx={{ textAlign: "right" }}>
                <Button
                  type="submit"
                  sx={{ width: { xs: "100%", md: "auto" } }}
                  className="btn-primary"
                  disableRipple
                  variant="contained"
                >
                  Continue
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>
      )}

      {progressBar && (
        <Box sx={{ textAlign: "center", mt: "1rem" }}>
          <CircularProgress size="6rem" className="progress-bar" />
          <Typography className="progress-title">
            We are veirifying the details of your vehicle. This may take a few seconds. Please
            wait...
          </Typography>
        </Box>
      )}

      {!verifyDetails && !progressBar && isSubmitted && !NocDetails && (
        <Box sx={{ textAlign: "center", mt: "1rem" }}>
          <img src={Alert} alt="not found" />
          <Typography className="alert">
            We have verified your details of the vehicle and your vehicle has been rejected for
            DriverTok application.
          </Typography>
        </Box>
      )}
      {verifyDetails && !progressBar && isSubmitted && <VehicleDetails />}
      {NocDetails && isSubmitted && (
        <NocDetail open={supportModal} onOpen={handleOpen} onClose={handleClose} />
      )}
    </Box>
  );
};
export default VehicleRegistration;
